import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import SearchIcon from "@mui/icons-material/Search";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { makeStyles } from "@mui/styles";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { useDispatch, useSelector } from "react-redux";
import Util from "../../validation";
import { getUpdateInvoicesCofig } from "../../redux/actions/updateInvoiceConfigAction";
import { getInvoicesCofig } from "../../redux/actions/getInvoiceConfigAction";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
import {
	resetGetCustomerIdAndNameList,
	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const MerchantConfiguration = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const classes = useStyles();
	const [merchantConfigurationStatus, setmerchantConfigurationStatus] =
		useState(false);
	const [merchantConfigurationArray, setMerchantConfigurationArray] = useState(
		[]
	);
	// console.log(merchantConfigurationArray, "merchantConfigurationArray");
	// console.log(merchantConfigurationArray, "merchantConfigurationArray");
	const [
		merchantConfigurationUpdateStatus,
		setmerchantConfigurationUpdateStatus
	] = useState(false);
	const [
		merchantConfigurationUpdateArray,
		setMerchantConfigurationUpdateArray
	] = useState([]);
	const [notificationOpen, setNotificationOpen] = useState(false);
	const [memberID, setMemberID] = useState("");
	const [user, setUser] = useState({
		upiSupportInvoice: "",
		payByLinkSupportInvoice: "",
		virtualCheckout: "",
		isShareAllowed: "",
		isSignatureAllowed: "",
		upiQRSupportInvoice: "",
		isMultipleRefund: "",
		isRefund: "",
		isEmailRequiredForVC: "",
		isMobileRequiredForVC: "",
		isPartialRefund: "",
		isSaveReceiptAllowed: "",
		AEPSSupportInvoice: "",
		generateInvoice: "",
		invoiceHistory: "",
		invoiceConfig: "",
		invoiceMerchantDetails: "",
		isIpWhiteList: ""
	});

	const {
		upiSupportInvoice,
		payByLinkSupportInvoice,
		virtualCheckout,
		isShareAllowed,
		isSignatureAllowed,
		upiQRSupportInvoice,
		isMultipleRefund,
		isRefund,
		isEmailRequiredForVC,
		isMobileRequiredForVC,
		isPartialRefund,
		isSaveReceiptAllowed,
		AEPSSupportInvoice,
		generateInvoice,
		invoiceHistory,
		invoiceConfig,
		invoiceMerchantDetails,
		isIpWhiteList
	} = user;

	const handleChange = ({ target: { name, value } }) => {
		if (name === "memberID") {
			setMemberID(value);
		}
	};

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getInvoiceConfigRes = useSelector(
		({ getInvoiceConfig }) => getInvoiceConfig
	);

	const updateInvoiceConfigRes = useSelector(
		({ updateInvoiceConfig }) => updateInvoiceConfig
	);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const merchantConfigurationReq = () => {
		setmerchantConfigurationStatus(true);
		setIsLoading(true);
		const req = {
			authentication: {
				memberId: memberID.split("-")[0]
			},
			merchant: {
				username: ""
			}
		};
		dispatch(getInvoicesCofig(req, authToken));
	};

	const merchantConfigurationReqFunc = () => {
		if (merchantConfigurationStatus) {
			if (getInvoiceConfigRes.data.statusInvoiceResult) {
				setMerchantConfigurationArray(getInvoiceConfigRes.data);
				setIsLoading(false);
				// if (getInvoiceConfigRes.data.statusInvoiceResult.description.includes('member')) {
				// 	NotificationPopups(
				// 		"error",
				// 		"Failed",
				// 		getInvoiceConfigRes.data.statusInvoiceResult.description
				// 	);
				// }
			}
			// if (getInvoiceConfigRes) {
			//   if (getInvoiceConfigRes.data.statusInvoiceResult) {
			//     if (getInvoiceConfigRes.data.statusInvoiceResult.code) {
			//       if (getInvoiceConfigRes.data.statuswInvoiceResult.code == "30001") {
			//         setMerchantConfigurationArray(getInvoiceConfigRes.data);
			//         NotificationPopups(
			//           "error",
			//           "Failed",
			//           getInvoiceConfigRes.data.statusInvoiceResult.description
			//         );
			//       }
			//     }
			//   }
			// }
		}
	};

	useEffect(() => {
		merchantConfigurationReqFunc();
	}, [getInvoiceConfigRes.success]);

	useEffect(() => {
		console.log(
			getInvoiceConfigRes,
			"///////////////////////////////////////////////////////////eee"
		);
	}, [getInvoiceConfigRes.data.statusInvoiceResult]);

	useEffect(() => {
		if (merchantConfigurationArray.invoiceDetails) {
			setUser({
				upiSupportInvoice:
					merchantConfigurationArray.invoiceDetails.upiSupportInvoice,
				payByLinkSupportInvoice:
					merchantConfigurationArray.invoiceDetails.payByLinkSupportInvoice,
				virtualCheckout:
					merchantConfigurationArray.invoiceDetails.virtualCheckout,
				isShareAllowed:
					merchantConfigurationArray.invoiceDetails.isShareAllowed,
				isSignatureAllowed:
					merchantConfigurationArray.invoiceDetails.isSignatureAllowed,
				upiQRSupportInvoice:
					merchantConfigurationArray.invoiceDetails.upiQRSupportInvoice,
				isMultipleRefund:
					merchantConfigurationArray.invoiceDetails.isMultipleRefund,
				isRefund: merchantConfigurationArray.invoiceDetails.isRefund,
				isEmailRequiredForVC:
					merchantConfigurationArray.invoiceDetails.isEmailRequiredForVC,
				isMobileRequiredForVC:
					merchantConfigurationArray.invoiceDetails.isMobileRequiredForVC,
				isPartialRefund:
					merchantConfigurationArray.invoiceDetails.isPartialRefund,
				isSaveReceiptAllowed:
					merchantConfigurationArray.invoiceDetails.isSaveReceiptAllowed,
				AEPSSupportInvoice:
					merchantConfigurationArray.invoiceDetails.AEPSSupportInvoice,
				generateInvoice:
					merchantConfigurationArray.invoiceDetails.generateInvoice,
				invoiceHistory:
					merchantConfigurationArray.invoiceDetails.invoiceHistory,
				invoiceConfig: merchantConfigurationArray.invoiceDetails.invoiceConfig,
				invoiceMerchantDetails:
					merchantConfigurationArray.invoiceDetails.invoiceMerchantDetails,
				isIpWhiteList: merchantConfigurationArray.invoiceDetails.isIpWhiteList
			});
		}
	}, [merchantConfigurationArray]);

	const merchantConfigurationUpdateReq = () => {
		setmerchantConfigurationUpdateStatus(true);
		const req = {
			authentication: {
				memberId: memberID.split("-")[0],
				partnerId: regenerateTokenRes.data.partnerId || ""
			},
			upiSupportInvoice: upiSupportInvoice,
			payByLinkSupportInvoice: payByLinkSupportInvoice,
			virtualCheckout: virtualCheckout,
			isShareAllowed: isShareAllowed,
			isSignatureAllowed: isSignatureAllowed,
			upiQRSupportInvoice: upiQRSupportInvoice,
			isMultipleRefund: isMultipleRefund,
			isRefund: isRefund,
			isEmailRequiredForVC: isEmailRequiredForVC,
			isMobileRequiredForVC: isMobileRequiredForVC,
			isPartialRefund: isPartialRefund,
			isSaveReceiptAllowed: isSaveReceiptAllowed,
			AEPSSupportInvoice: AEPSSupportInvoice,
			generateInvoice: generateInvoice,
			invoiceHistory: invoiceHistory,
			invoiceConfig: invoiceConfig,
			invoiceMerchantDetails: invoiceMerchantDetails,
			isIpWhiteList: isIpWhiteList
		};
		return dispatch(getUpdateInvoicesCofig(req, authToken));
	};

	const updateMerchantConfigurationReqFunc = () => {
		if (merchantConfigurationUpdateStatus) {
			setMerchantConfigurationUpdateArray(updateInvoiceConfigRes.data);
			setNotificationOpen(true);
			merchantConfigurationReq();
		}
	};

	useEffect(() => {
		updateMerchantConfigurationReqFunc();
	}, [updateInvoiceConfigRes.success]);

	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const getMerchantConfigReq = () => {
		setNotificationOpen(true);
	};

	// const filterOptions = createFilterOptions({
	// 	matchFrom: "any",
	// 	limit: 500
	// });

	const filterOptions = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Autocomplete 
							
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptions}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Member ID"
										required
										variant="standard"
										type="text"
										fullWidth
										{...params}
										value={memberID}
										name="memberID"
										onBlur={handleChange}
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
										// InputProps={{
										// 	sx: {
										// 	  "&:before": { borderBottomColor: "gray" }, // before focus
										// 	  "&:after": { borderBottomColor: "gray" },  // after focus
										// 	},
										//   }}
										//   InputLabelProps={{
										// 	sx: { color: 'gray' }, // Optional: if you want the label to be white
										//   }}
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={2} lg={2}>
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                  textAlign: "center",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={merchantConfigurationReq}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={merchantConfigurationReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : merchantConfigurationArray.invoiceDetails == undefined ||
					!merchantConfigurationStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Configuration Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<>
						<TableContainer component={Paper} style={{ marginTop: "15px" }}>
							<Typography
								className="themeText"
								variant="body1"
								style={{
									textAlign: "center",
									margin: "10px 0",
									// color: "#01367e",
									fontSize: "1.4rem"
								}}
							>
								Invoicing
							</Typography>

							<Table
								className={classes.table}
								aria-label="a dense table"
								style={{ whiteSpace: "nowrap" }}
							>
								<TableHead>
									<TableRow className="tableHeaderColor">
										<TableCell
											align="center"
											style={{
												fontSize: "15px",
												fontWeight: "bold",
												color: "white"
											}}
										>
											Generate Invoice{" "}
										</TableCell>
										<TableCell
											align="center"
											style={{
												fontSize: "15px",
												fontWeight: "bold",
												color: "white"
											}}
										>
											Invoice History{" "}
										</TableCell>
										<TableCell
											align="center"
											style={{
												fontSize: "15px",
												fontWeight: "bold",
												color: "white"
											}}
										>
											Invoice Configuration
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									<TableRow className="">
										<TableCell align="center">
											<TextField
												select
												size="medium"
												color="primary"
												autoFocus={true}
												type="text"
												value={generateInvoice}
												name="generateInvoice"
												fullWidth={true}
												onChange={onInputChange}
											// defaultValue="Y"
											>
												<MenuItem
													value={"Y"}
												// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
												>
													Y
												</MenuItem>
												<MenuItem
													value={"N"}
												// onClick={() => getCurrIdx(index, "N", "isDisplay")}
												>
													N
												</MenuItem>
											</TextField>
										</TableCell>
										<TableCell align="center">
											<TextField
												select
												size="medium"
												color="primary"
												autoFocus={true}
												type="text"
												value={invoiceHistory}
												name="invoiceHistory"
												fullWidth={true}
												onChange={onInputChange}
											// onChange={handleChange}
											// defaultValue="Y"
											>
												<MenuItem
													value={"Y"}
												// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
												>
													Y
												</MenuItem>
												<MenuItem
													value={"N"}
												// onClick={() => getCurrIdx(index, "N", "isDisplay")}
												>
													N
												</MenuItem>
											</TextField>
										</TableCell>
										<TableCell align="center">
											<TextField
												select
												size="medium"
												color="primary"
												autoFocus={true}
												type="text"
												value={invoiceConfig}
												name="invoiceConfig"
												fullWidth={true}
												onChange={onInputChange}
											// onChange={handleChange}
											// defaultValue="Y"
											>
												<MenuItem
													value={"Y"}
												// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
												>
													Y
												</MenuItem>
												<MenuItem
													value={"N"}
												// onClick={() => getCurrIdx(index, "N", "isDisplay")}
												>
													N
												</MenuItem>
											</TextField>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>

						<TableContainer component={Paper} style={{ marginTop: "15px" }}>
							<Typography
								className="themeText"
								variant="body1"
								style={{
									textAlign: "center",
									margin: "10px 0",
									// color: "#01367e",
									fontSize: "1.4rem"
								}}
							>
								Invoice Configuration
							</Typography>

							{
								<Table
									className={classes.table}
									aria-label="a dense table"
									style={{ whiteSpace: "nowrap" }}
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Invoice Merchant Details{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Is IP whitelist for Invoice{" "}
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										<TableRow>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={invoiceMerchantDetails}
													name="invoiceMerchantDetails"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={isIpWhiteList}
													name="isIpWhiteList"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							}
						</TableContainer>

						<TableContainer component={Paper} style={{ marginTop: "15px" }}>
							<Typography
								variant="body1"
								className="themeText"
								style={{
									textAlign: "center",
									margin: "10px 0",
									// color: "#01367e",
									fontSize: "1.4rem"
								}}
							>
								Invoizer Configuration
							</Typography>

							{
								<Table
									className={classes.table}
									aria-label="a dense table"
									style={{ whiteSpace: "nowrap" }}
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Is Virtual Checkout Allowed
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Is Phone Required
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Is Email Required
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										<TableRow>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={virtualCheckout}
													name="virtualCheckout"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={isMobileRequiredForVC}
													name="isMobileRequiredForVC"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={isEmailRequiredForVC}
													name="isEmailRequiredForVC"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
										</TableRow>
									</TableBody>

									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Is Share Allowed
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Is Signature Allowed
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Is Save Receipt Allowed
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										<TableRow>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={isShareAllowed}
													name="isShareAllowed"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={isSignatureAllowed}
													name="isSignatureAllowed"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={isSaveReceiptAllowed}
													name="isSaveReceiptAllowed"
													fullWidth={true}
													onChange={onInputChange}
												// defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							}
						</TableContainer>

						<TableContainer component={Paper} style={{ marginTop: "15px" }}>
							<Typography
								variant="body1"
								className="themeText"
								style={{
									textAlign: "center",
									margin: "10px 0",
									// color: "#01367e",
									fontSize: "1.4rem"
								}}
							>
								Transaction Configuration
							</Typography>

							{
								<Table
									className={classes.table}
									aria-label="a dense table"
									style={{ whiteSpace: "nowrap" }}
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												UPI Support Invoice
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												UPI QR Support Invoice
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												Pay By Link Support Invoice
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: "15px",
													fontWeight: "bold",
													color: "white"
												}}
											>
												AEPS Support Invoice
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										<TableRow>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={upiSupportInvoice}
													name="upiSupportInvoice"
													fullWidth={true}
													onChange={onInputChange}
													defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={upiQRSupportInvoice}
													name="upiQRSupportInvoice"
													fullWidth={true}
													onChange={onInputChange}
													defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={payByLinkSupportInvoice}
													name="payByLinkSupportInvoice"
													fullWidth={true}
													onChange={onInputChange}
													defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
											<TableCell align="center">
												<TextField
													select
													size="medium"
													color="primary"
													autoFocus={true}
													type="text"
													value={AEPSSupportInvoice}
													name="AEPSSupportInvoice"
													fullWidth={true}
													onChange={onInputChange}
													defaultValue="Y"
												>
													<MenuItem
														value={"Y"}
													// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
													>
														Y
													</MenuItem>
													<MenuItem
														value={"N"}
													// onClick={() => getCurrIdx(index, "N", "isDisplay")}
													>
														N
													</MenuItem>
												</TextField>
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							}
						</TableContainer>

						<TableContainer component={Paper} style={{ marginTop: "15px" }}>
							<Typography
								className="themeText"
								variant="body1"
								style={{
									textAlign: "center",
									margin: "10px 0",
									// color: "#01367e",
									fontSize: "1.4rem"
								}}
							>
								Refund Configuration
							</Typography>

							<Table
								className={classes.table}
								aria-label="a dense table"
								style={{ whiteSpace: "nowrap" }}
							>
								<TableHead>
									<TableRow className="tableHeaderColor">
										<TableCell
											align="center"
											style={{
												fontSize: "15px",
												fontWeight: "bold",
												color: "white"
											}}
										>
											Is Refund{" "}
										</TableCell>
										<TableCell
											align="center"
											style={{
												fontSize: "15px",
												fontWeight: "bold",
												color: "white"
											}}
										>
											Is Multiple Refund{" "}
										</TableCell>
										<TableCell
											align="center"
											style={{
												fontSize: "15px",
												fontWeight: "bold",
												color: "white"
											}}
										>
											is Partial Refund
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									<TableRow>
										<TableCell align="center">
											<TextField
												select
												size="medium"
												color="primary"
												autoFocus={true}
												type="text"
												value={isRefund}
												name="isRefund"
												fullWidth={true}
												onChange={onInputChange}
											// defaultValue="Y"
											>
												<MenuItem
													value={"Y"}
												// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
												>
													Y
												</MenuItem>
												<MenuItem
													value={"N"}
												// onClick={() => getCurrIdx(index, "N", "isDisplay")}
												>
													N
												</MenuItem>
											</TextField>
										</TableCell>
										<TableCell align="center">
											<TextField
												select
												size="medium"
												color="primary"
												autoFocus={true}
												type="text"
												value={isMultipleRefund}
												name="isMultipleRefund"
												fullWidth={true}
												onChange={onInputChange}
											// defaultValue="Y"
											>
												<MenuItem
													value={"Y"}
												// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
												>
													Y
												</MenuItem>
												<MenuItem
													value={"N"}
												// onClick={() => getCurrIdx(index, "N", "isDisplay")}
												>
													N
												</MenuItem>
											</TextField>
										</TableCell>
										<TableCell align="center">
											<TextField
												select
												size="medium"
												color="primary"
												autoFocus={true}
												type="text"
												value={isPartialRefund}
												name="isPartialRefund"
												fullWidth={true}
												onChange={onInputChange}
											// defaultValue="Y"
											>
												<MenuItem
													value={"Y"}
												// onClick={() => getCurrIdx(index, "Y", "isDisplay")}
												>
													Y
												</MenuItem>
												<MenuItem
													value={"N"}
												// onClick={() => getCurrIdx(index, "N", "isDisplay")}
												>
													N
												</MenuItem>
											</TextField>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
							<Grid
								container
								style={{
									padding: "10px",
									marginTop: "1.5rem",
									marginBottom: "15px"
								}}
							>
								<Grid item md={5}></Grid>
								<Grid item md={2}>
									{/* <Button
										style={{
											marginLeft: "0.7rem",
											backgroundColor: "#00b9f5",
											color: "white"
										}}
										endIcon={<AiOutlineSearch />}
										variant="contained"
										onClick={merchantConfigurationUpdateReq}
									>
										save
									</Button> */}
									<CustomButton
										style={{
											padding: "8px"
										}}
										onClick={merchantConfigurationUpdateReq}
									>
										Save
									</CustomButton>
								</Grid>
								<Grid item md={5}></Grid>
							</Grid>
						</TableContainer>
					</>
				)}
			</Layout>

			{merchantConfigurationUpdateArray &&
				merchantConfigurationUpdateArray.statusInvoiceResult &&
				merchantConfigurationUpdateArray.statusInvoiceResult.code ==
				"00020" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{
										merchantConfigurationUpdateArray.statusInvoiceResult
											.description
									}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

			{merchantConfigurationUpdateArray &&
				merchantConfigurationUpdateArray.statusInvoiceResult &&
				merchantConfigurationUpdateArray.statusInvoiceResult.code !==
				"00020" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{
										merchantConfigurationUpdateArray.statusInvoiceResult
											.description
									}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

			{/* {updateFeeManagementListArray.status == "success" && ( */}
			<div>
				{/* <Dialog open={notificationOpen} onClose={handleNoticationClose}>
          <DialogContent
            className="text-center"
            style={{ backgroundColor: "#00b9f51c" }}
          >
            <img src={success} alt="" width="100px" className="my-2" />
          </DialogContent>
          <DialogContent>
            <h4 style={{ margin: "0", textAlign: "center", fontSize: "15px" }}>
              Record Updated Successfully
            </h4>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Button
              style={{
                margin: "10px 0",
                backgroundColor: "#00b9f5",
                color: "white",
              }}
              variant="contained"
              onClick={handleNoticationClose}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog> */}
			</div>
			{/* )} */}

			{/* {updateFeeManagementListArray.status == "failed" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {updateFeeManagementListArray.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}
		</>
	);
};

export default MerchantConfiguration;
